import { render, staticRenderFns } from "./SBBasicInformation.vue?vue&type=template&id=e4de8f02"
import script from "./SBBasicInformation.vue?vue&type=script&lang=js"
export * from "./SBBasicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports